module.exports = __webpack_public_path__ + "img/jo1.59509c34.png";